import * as React from 'react';
const SvgDiamondHalf = (props) => (React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { d: "M15.895 2.457A1.562 1.562 0 0 1 17 2V22c-.398 0-.8-.152-1.105-.457l-8.438-8.438a1.566 1.566 0 0 1 0-2.21l8.438-8.438Zm-.77 15.664V5.88L9.004 12l6.121 6.121Z", fill: "currentColor" })));
export default SvgDiamondHalf;
